<template>
  <div class="heading heading-container">
    <h2>
      <i v-if="data.icon" :class="`icon-${data.icon}`"></i>
      {{ data.caption }}
    </h2>
    <Baseline v-if="data.baseline" :data="data.baseline" />
  </div>
</template>

<script>
import Baseline from '@/components/Screen/Baseline';
export default {
  components: {
    Baseline,
  },

  props: ['data'],
};
</script>

<style lang="scss">
@use '@/styles/colors.scss';
.heading {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  h2 {
    display: flex;
    flex: 1;
    height: 75px;

    i {
      display: block;
    }
  }
  .baseline {
    display: flex;
    align-items: flex-end;
    .caption {
      font-size: 1.75em;
      font-weight: 300;
    }
    .data-value {
      font-size: 4.375em;
      line-height: 0.875;
      margin-left: 0.125em;
    }
  }
}
</style>
